export default __webpack_public_path__ + "static/media/ponds.63d6b3cb.png";